<template>
  <el-checkbox
    v-model="checked"
    :disabled="disabled"
    @change="changeCheck">
    <slot></slot>
  </el-checkbox>
</template>
<script>
export default {
  name: 'VCheckbox',
  props: {
    value: {
      type: [String, Boolean, Number],
      default: false
    },
    disabled:{
      type:Boolean,
      default: false
    },
    isBoolean: {
      type: Boolean,
      default: true //  準備改成 false todo
    },
    selectNumber:{
      type: [Boolean, Number],
      default: 1
    },
    noNumber:{
      type: [Boolean, Number],
      default: 0
    },
    otherData:{
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      checked: false
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(val) {
        this.checked = val==this.selectNumber
        let result = this.isBoolean? val: Number(val)
        if(!this.isBoolean&&this.noNumber>0){
          result = this.checked?this.selectNumber:this.noNumber
        }
        if(!this.isBoolean&&this.selectNumber>1){
          result = this.checked?this.selectNumber:0
        }
        this.$emit('input', result)
      }
    },
  },
  methods: {
    changeCheck(val) {
      let result = this.isBoolean? val: Number(val)
      if(!this.isBoolean&&this.noNumber>0){
        result = this.checked?this.selectNumber:this.noNumber
      }
      if(!this.isBoolean&&this.selectNumber>1){
        result = this.checked?this.selectNumber:this.noNumber
      }
      this.$emit('input', result)
      this.$emit('change', result, this.otherData)
    }
  }
}
</script>
<style lang="scss" scoped>
 .el-checkbox{
  display: flex;
  align-items: center!important;
   /deep/.el-checkbox__label{
      white-space: normal;
}
}
</style>
